import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Lookup } from 'src/app/models/Lookup';
import { map, Observable, startWith } from 'rxjs';

@Component({
  selector: 'app-tags-selector-search',
  templateUrl: './tags-selector-search.component.html'
})
export class TagsSelectorSearchComponent implements OnInit {
  @Input() loading = true;
  @Input() isRequired = false;
  @Input() disabled = false;
  @Input() isSubmitted = false;
  @Input() list: any[] = [];
  @Input() label!: string;
  @Output() selectedItems = new EventEmitter<Lookup[]>();

  searchCtr = new FormControl<string | Lookup>('');
  filteredList!: Observable<Lookup[]>;
  @Input() selectedList: Lookup[] = [];

  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['loading']?.currentValue == false) {
      this.initListFiltiration();
    }
    if (changes['isSubmitted']?.currentValue && this.isRequired) {
      this.hasError();
    }
  }

  initListFiltiration() {
    this.filteredList = this.searchCtr.valueChanges.pipe(
      startWith(''),
      map(value => {
        const name = typeof value === 'string' ? value : value?.name;
        return name ? this._filter(name as string) : this.list.slice();
      }),
    );
  }
  displayFn(item: Lookup): string {
    return item && item.name ? item.name : '';
  }
  private _filter(name: string): Lookup[] {
    const filterValue = name.toLowerCase();
    return this.list.filter(item => item.name.toLowerCase().includes(filterValue));
  }
  selected(value: Lookup) {
    if (!this.isSelected(value)) {
      this.selectedList.push(value);
    } else {
      let index = this.selectedList.findIndex(item => item.id === value.id)
      if (index >= 0) {
        this.selectedList.splice(index, 1);
      }
    }
    this.searchCtr.setValue('');
    this.selectedItems.emit(this.selectedList);
  }
  removeSelected(i: number) {
    this.selectedList.splice(i, 1);
    this.selectedItems.emit(this.selectedList);
  }
  isSelected(v: Lookup) {
    return this.selectedList.some(item => item.id === v.id)
  }

  hasError() {
    if (!this.selectedList.length && this.isRequired) {
      this.searchCtr.setErrors({required: true});
    } else {
      this.searchCtr.setErrors(null);
    }
    this.searchCtr.markAsTouched()
  }
}
